

export function checkCodeWeight(code,weightEven=3,weightUneven=1,offset=0)
{
  if(isNaN(code))
        return true
    let sum=0
    for( let i=0;i<code.length-1;++i)
    {
        const char=code.charAt(i)
        if(!isNaN(char))
        {
            if(i % 2 === 0)
                sum+=weightEven*(parseInt(char))
            else
                sum+=weightUneven*(parseInt(char))

        }
    }
    sum=10 - ((sum +offset) % 10) %10
    if(sum===10)
        sum=0

    return( sum === parseInt(code.charAt(code.length-1)) )
}

export function checkCodeWeightB(code,weightEven=3,weightUneven=1,offset=0)
{
  if(isNaN(code))
        return true
    let sum=0
    for( let i=code.length-2;i>=0;--i)
    {
        const char=code.charAt(i)
        if(!isNaN(char))
        {
            if(i % 2 === 0)
                sum+=weightEven*(parseInt(char,10))
            else
                sum+=weightUneven*(parseInt(char,10))

        }
    }
    sum=10 - ((sum+offset)  % 10) %10

    return( sum === parseInt(code.charAt(code.length-1),10) )
}

export function checkCodeDHLE(code,praefix='')
{   
    const myCode=code.replace(/^]C1|^%/,'')
    if(praefix!=='' && new RegExp('/^'+praefix+'[0-9]{4,}/').test(myCode) )
        return true
    if(myCode.length!==10)
        return checkCodeDHL(code)
    const div10=(myCode.substring(0,9)*10/7).toString(10)
    const rest10=(div10.charAt(8)*7/10).toString(10)
    const pz=(Math.floor(rest10)+1).toString(10)
    return( pz === myCode.charAt(9))
}

export function checkCodeDHL(code)
{
    const myCode=code.replace(/^]C1|^%/,'')
    if(/^JJD[0-9]{8,}/.test(myCode) )
        return true
    if(/^JVGL[0-9]{8,}/.test(myCode) )
        return true
    if(myCode.length=== 12)
        return (checkCodeWeight(myCode,4,9))
    if(myCode.length===20)
        return (checkCodeWeight(myCode))
    else 
        return false
  
}

export function checkCodeGLSOld(code)
{

    if(code.length!==12)
    {
        return false
    }
    else
    {
        return checkCodeWeightB(code,3,1,1)
    }
}

export function checkCodeGLS(code)
{
    if(!code)
        return false
    const elements=code.split(' ')
    if(elements.length <2)
        return false
    if(code.match(/\s+\d{6,}[0-4a-z]*{?([A-Z].[A-Z0-9]{8,})\s/))
        return true
    else
        return false
    
}

export function checkCodeHermes(code)
{
    const myCode=code.replace(/^]C1|^%/,'')
    let newCode=myCode
    // strip H am Anfang
    if(myCode.charAt(0)==='H' && myCode.length>10)
        return true
    if(!myCode.length>=8)
    {
        return false
    }
    else
    {
        newCode=myCode.substr(1)
 
        return checkCodeWeight(newCode)
    }
}

export function checkCodeDPD(code)
{
    // strip %0078262 am Anfang und Rest am Ende
    const myCode=code.replace(/^]C1|^%/,'')
    if(isNaN(myCode))
        return false
    else
        return true
}
  
export function checkCodeUPS(code)
{
    const myCode=code.replace(/^]C1|^%/,'')
    if(myCode.charAt(0)!=='1' || myCode.charAt(1)!=='Z')
        return false
    const translate = {
            '0':0,
            '1':1,
            '2':2,
            '3':3,
            '4':4,
            '5':5,
            '6':6,
            '7':7,
            '8':8,
            '9':9,
            A:2,
            B:3,
            C:4,
            D:5,
            E:6,
            F:7,
            G:8,
            H:9,
            I:0,
            J:1,
            K:2,
            L:3,
            M:4,
            N:5,
            O:6,
            P:7,
            Q:8,
            R:9,
            S:0,
            T:1,
            U:2,
            V:3,
            W:4,
            X:5,
            Y:6,
            Z:7
    }
    let newCode=''
    for( let i=2;i<myCode.length;++i)
    {
        newCode+=translate[myCode.charAt(i)]
    }
    return checkCodeWeight(newCode,1,2)
}
export function checkCodeBrief(code,praefix='')
{
    const myCode=code.replace(/^]C1|^%/,'')
    if(praefix!=='' && new RegExp('/^'+praefix+'[0-9]{4,}/').test(myCode) )
        return true
    else
        return false
}

export function checkCodePrime(code)
{
    let newCode=code
    if(!code.length>=8)
    {
        return false
    }
    else
    {
        return true
    }
}

const checkCodes =
{
    DHL:checkCodeDHL,
    EXPRESS: checkCodeDHLE,
    GLS: checkCodeGLS,
    HERMES: checkCodeHermes,
    DPD: checkCodeDPD,
    UPS: checkCodeUPS,
    Brief: checkCodeBrief,
    PRIME: checkCodePrime

}
export default checkCodes
